import React, { Outlet, useLocation } from "react-router-dom";
import Navbar from "../../components/player/Navbar.tsx";
import MenuLeague from "../../components/player/typeGame/commercial/MenuLeague.tsx";
import "../../styles/Navigation.css";
import { usePlayerChrome } from "../../hooks/usePlayerChrome.ts";

const CommercialComponent = () => {
    usePlayerChrome();
    const location = useLocation();
    const isPropsPage = location.pathname.includes("/props");

    return (
        <div className="player-layout commercial-live-shell">
            <Navbar />
            <div
                className={
                    isPropsPage
                        ? "grow padding-top player-main-surface commercial-live-surface"
                        : "custom-container grow color-live-container player-main-surface commercial-live-surface"
                }
                style={{ flex: "1 1 auto", width: "100%", minHeight: 0 }}
            >
                <div className="row" hidden={isPropsPage} aria-hidden={isPropsPage}>
                    <div className="col-12">
                        <MenuLeague />
                    </div>
                </div>
                <div className="row">
                    <div className="col-12">
                        <Outlet />
                    </div>
                </div>
            </div>
        </div>
    );
}
export default CommercialComponent;
